import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

export default class extends Controller {
  static targets = ["selectCampaign", "newCampaignName", "addButton",
    "newCampaignNameError", "dropdownTrigger"]
  static values = {
    campaignId: Number, campaignName: String, hasCampaigns: Boolean,
    leadEmail: String, source: String
  }

  connect() {
    const _this = this

    if (this.hasCampaignsValue) {
      this.campaignsListSelectize = $(this.selectCampaignTarget).selectize()
      this.campaignsListSelectize[0].selectize.on("change", function (value) {
        _this.changeCampaign(value, "")
      })
    }
  }

  disconnect() {
    // Destroy the Selectize element to avoid duplication of the field
    if (this.campaignsListSelectize !== undefined) {
      this.campaignsListSelectize[0].selectize.destroy()
    }
  }

  dismiss() {
    // Close the dropdown by clicking on the button
    // the toggle method is not working well here
    this.dropdownTriggerTarget.click()
  }

  campaignTypeSelection(event) {
    if (event.params.type === "new") {
      this.newCampaignNameTarget.disabled = false
      this.newCampaignNameTarget.required = true
      this.campaignsListSelectize[0].selectize.disable()
      this.addButtonTarget.dataset.action = "lead-campaigns-manager#createCampaign"
      this.changeCampaign("", this.newCampaignNameTarget.value)
    } else if (event.params.type === "existing") {
      this.newCampaignNameTarget.disabled = true
      this.newCampaignNameTarget.required = false
      this.campaignsListSelectize[0].selectize.enable()
      this.addButtonTarget.dataset.action = "lead-campaigns-manager#add"
      this.changeCampaign(this.selectCampaignTarget.value, "")
    }
  }

  // Create a new campaign
  createCampaign(e) {
    e.preventDefault()
    const data = { emails: this.leadEmailValue, action_source: this.sourceValue, name: this.newCampaignNameTarget.value }
    const _this = this

    if (this.newCampaignNameTarget.value.length == 0) {
      this.newCampaignNameTarget.focus()
      return this.newCampaignNameErrorTarget.classList.remove("d-none")
    }

    fetch("/campaigns", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content")
      },
      body: JSON.stringify(data)
    }).then(response => {
      if (!response.ok) { throw response.json() }
      return response.json()
    }).then(json => {
      _this.campaignIdValue = json.id
      _this.campaignNameValue = json.name
      _this.newCampaignNameTarget.value = ""
      _this.newCampaignNameErrorTarget.classList.add("d-none")
      _this.add()
      this.dispatch("campaignCreated", { detail: { id: json.id } })
      App.analytics.posthog_capture("Lead campaign manager: Campaign created")
    }).catch(error => {
      this.dispatch("error")
      error.then(data => {
        App.displayFlash("danger", data.errors[0].details)
      })
    })
  }

  // Add lead to the campaign
  add() {
    const _this = this
    const campaignName = this.campaignNameValue
    const recipient = { "emails": this.leadEmailValue }

    fetch(App.api.addToCampaign(this.campaignIdValue), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(recipient)
    }).then(response => {
      if (!response.ok) { throw response.json() }
      return response.json()
    }).then(json => {
      _this.dismiss()

      if (json.data.recipients_added === 0) {
        // We actually didn't add any recipients, lets see why
        const reasonWhyLeadWasntAdded = json.data.skipped_recipients[0]["reason"]

        if (["duplicate", "unsubscribed", "bounced", "removed"].includes(reasonWhyLeadWasntAdded)) {
          const translation = i18n.t(`js.back.lead_campaigns_manager.${reasonWhyLeadWasntAdded}`, { lead: json.meta.params.emails, campaign: campaignName })
          App.displayFlash("warning", translation)
        } else {
          App.displayFlash("warning", i18n.t("js.back.lead_campaigns_manager.not_added", { lead: json.meta.params.emails, campaign: campaignName }))
        }
      } else {
        this.dispatch("added", { detail: { lead: json.meta.params.emails } })
        App.displayFlash("success", i18n.t("js.back.lead_campaigns_manager.added", { lead: json.meta.params.emails, campaign: campaignName }))
      }

      App.analytics.posthog_capture("Lead campaign manager: Email created")
    }).catch(error => {
      this.dispatch("error")
      error.then(data => {
        App.displayFlash("danger", data.errors[0].details)
      })
    })
  }

  // When user change campaign update associated values
  changeCampaign(id, name) {
    if (id) {
      // If id is present it's an existing campaign
      this.campaignIdValue = id
      this.campaignNameValue = this.selectCampaignTarget.options[this.selectCampaignTarget.selectedIndex].text
    } else {
      // else it's a new campaign that will be created
      this.campaignIdValue = ""
      this.campaignNameValue = name
    }
  }

  updateCampaignName(event) {
    this.changeCampaign("", event.target.value)
  }

  // Get campaigns and update the <select> -
  // triggered when a campaign is created (campaignCreated event)
  updateCampaignsList(event) {
    const _this = this
    const currentCampaignId = event.detail.id

    fetch(App.api.getUnarchivedCampaigns(50))
      .then(response => {
        if (!response.ok) { throw new Error(response.status) }

        return response.json()
      }).then(response => {
        // Destroy selectize
        if (this.campaignsListSelectize) {
          this.campaignsListSelectize[0].selectize.destroy()
          delete this.campaignsListSelectize
        }

        this.selectCampaignTarget.innerHTML = ""
        response.data.campaigns.forEach(campaign => {
          const option = document.createElement("option")
          option.setAttribute("value", campaign.id)
          option.textContent = campaign.name

          if (campaign.id === currentCampaignId) {
            option.setAttribute("selected", true)
          }

          this.selectCampaignTarget.appendChild(option)
        })

        // And recreate it once the list has been refreshed
        this.campaignsListSelectize = $(this.selectCampaignTarget).selectize()
        this.campaignsListSelectize[0].selectize.on("change", function (value) {
          _this.changeCampaign(value, "")
        })
      }).catch(error => {
        if (error.message === "500") {
          App.displayFlash("danger", i18n.t("js.front.api_errors.internal_server_error"))
        }
      })
  }
}
